export default __webpack_public_path__ + "static/media/p-minus-1.4e49e13a.svg";